import React from "react";
import OrderDisclosure from "./OrderDisclosure";

function groupName(field = "") {
  if (field.startsWith("recipient.")) return "Odbiorca";
  if (field.startsWith("items") || field === "grossWeight")
    return "Towary i ilości";
  return "Dane świadectwa";
}

export default function ReviewWarnings({
  issues,
  warnings,
  items,
  dirty,
  busy,
  onSelect,
}) {
  const groups = new Map();
  const currentItems = new Set(items.map((item) => item.id));
  const visible = (issues || warnings.map((message) => ({ message }))).filter(
    (issue) =>
      (!issue.itemId || currentItems.has(issue.itemId)) &&
      (issue.field !== "items" || !items.length),
  );
  if (!visible.length) return null;
  for (const issue of visible) {
    const group = groupName(issue.field);
    if (!groups.has(group)) groups.set(group, []);
    groups.get(group).push(issue);
  }
  return (
    <OrderDisclosure
      title="Warto uzupełnić dane"
      icon="bi-exclamation-circle"
      count={visible.length}
      variant="warning"
    >
      <p>
        {dirty
          ? "Uwagi dotyczą ostatnio zapisanych danych. Zapisz zmiany, aby odświeżyć listę."
          : "Poniższe uwagi nie blokują wystawienia świadectwa."}
      </p>
      <div className="premium-review-issues">
        {Array.from(groups, ([group, entries]) => (
          <section key={group}>
            <h3>{group}</h3>
            {entries.map((issue, index) =>
              issue.field ? (
                <button
                  key={index}
                  type="button"
                  onClick={() => onSelect(issue)}
                  disabled={busy}
                >
                  <span>{issue.message}</span>
                  <i className="bi bi-arrow-right" aria-hidden="true" />
                </button>
              ) : (
                <p key={index}>{issue.message}</p>
              ),
            )}
          </section>
        ))}
      </div>
    </OrderDisclosure>
  );
}
